import {Switch,Route,Redirect} from "react-router-dom"
import CardCreate from "./card-create"
const Card =()=>{  
    return(
        <Switch>
            <Route path="/card/create" component={CardCreate}></Route>

            <Redirect to="/card/create"></Redirect>
        </Switch>
    )
}

export default Card